import Div from 'src/components/atomic/atom/Div'
import Section from 'src/components/atomic/atom/Section'
import Span from 'src/components/atomic/atom/Span'
import CheckBox from 'src/components/atomic/atom/CheckBox'
import { ExplorerDeleteDataPropsType } from 'src/views/Service/Explorer/Delete'
import { useAppSelector } from 'src/hooks/redux/useAppSelector'
import { RootState } from 'src/store/store'
import useMediaQueryHook from 'src/hooks/useMediaQuery.hook'
import { useTranslation } from 'react-i18next'

const ExplorerDeleteContents = (props: { data: ExplorerDeleteDataPropsType }) => {
  const { handleCheckBox } = props.data
  const { setMediaStyle } = useMediaQueryHook()
  const { t } = useTranslation()
  const { ExplorerDeleteCheckList } = useAppSelector((state: RootState) => state.ExplorerPage)
  const DeleteNoticeTextList = Object.values(
    t('EXPLORER.DELETE.TERMS.CONTENTS', {
      defaultValue: [
        'Are about to delete all files, including photos, video clips and audio files.',
        'Are about to delete all files, including documents and APK packages.',
        'Understand that deletion of data cannot be undone.',
        'Have properly backed up the data you are about to delete.',
      ],
      returnObjects: true,
    }),
  )

  return (
    <Div
      display={'flex'}
      $flex_wrap={'wrap'}
      $margin={setMediaStyle('24px auto 40px auto', '16px auto 44px auto', '20px auto 38px auto')}
      $gap={setMediaStyle('24px', '12px', '12px')}
    >
      {DeleteNoticeTextList.map((element, index) => (
        <Section
          key={element}
          width={'100%'}
          display={'flex'}
          $gap={setMediaStyle('24px', '10px', '10px')}
        >
          <Span
            $text_align={'left'}
            option={setMediaStyle('small', 'tiny', 'tiny')}
            $line_height={setMediaStyle('', '48px', '24px')}
          >
            {element}
          </Span>
          <CheckBox
            size={'20px'}
            onChange={() => handleCheckBox(index)}
            checked={ExplorerDeleteCheckList[index]}
          />
        </Section>
      ))}
    </Div>
  )
}
export default ExplorerDeleteContents
